export enum MessageChannel {
  BID_LIST = 'BID_LIST'
}

